import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Label, Row, Spinner } from 'reactstrap';
import CBToolTip from '../../../components/CBToolTip';
import { PostData } from '../../../services/FetchData';
import Cookies from 'js-cookie';

const AiAssistantWooCommerceSettings = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [websiteKeys, setWebsiteKeys] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [copyTexts, setCopyTexts] = useState({
		apiKey: "Copy to clipboard",
	});

	const hardcodedKeys = [
		{ key: 'apiKey', label: 'Api Key' },
	];

	useEffect(() => {
		if (location.state && location.state.websiteKeys) {
			setWebsiteKeys(location.state.websiteKeys);
		} else {
			navigate("/getStarted/aiAssistantWooCommerce", { replace: true });
		}
	}, [location.state, navigate]);

	const getValueForKey = (keyName) => {
		const keyItem = websiteKeys.find(item => item.websiteIntegrationKey === keyName);
		return keyItem ? keyItem.websiteIntegrationValue || "" : "";
	}

	const handleCopy = (key, value) => {
		if (value) {
			navigator.clipboard.writeText(value).then(() => {
				setCopyTexts(prev => ({
					...prev,
					[key]: "Copied"
				}));
				setTimeout(() => {
					setCopyTexts(prev => ({
						...prev,
						[key]: "Copy to clipboard"
					}));
				}, 2000);
			}).catch(err => {
				console.error('Failed to copy text: ', err);
			});
		}
	}

	const handleGoToDashboard = (e) => {
		e.preventDefault();
		e.stopPropagation();

		const storeURL = location.state?.storeURL;
		setIsLoading(true);

		PostData("ms1", "api/v1/user/getUserDetail").then(userDetailResult => {
			setIsLoading(false);
			if (userDetailResult && userDetailResult.status === "success" && userDetailResult.data.websites && storeURL) {
				const matchingWebsite = userDetailResult.data.websites.find(website => {
					const websiteUrl = (website.websiteURL || "").replace(/\/$/, "").toLowerCase();
					const addedUrl = storeURL.replace(/\/$/, "").toLowerCase();
					return websiteUrl === addedUrl || websiteUrl.includes(addedUrl) || addedUrl.includes(websiteUrl);
				});

				if (matchingWebsite && matchingWebsite.websiteId) {
					Cookies.set('_website_id', matchingWebsite.websiteId);
				}
			}
			window.location.href = "/user/dashboard";
		}).catch(() => {
			setIsLoading(false);
			window.location.href = "/user/dashboard";
		});
	}

	return (
		<>
			<section className='choosePlatformHeader'>
				<div className='container'>
					<Row className="align-items-center justify-content-center">
						<Col xs={"auto"}>
							<h2 className='mt-5'>AI Assistant WooCommerce Settings</h2>
						</Col>
					</Row>
				</div>
			</section>
			<section className='shopifyAppInstallationGuide mt-5'>
				<div className='container'>
					<Row className='align-items-center justify-content-center'>
						<Col xs={12} lg={4}>
							<div className='cardDisplay cardDisplayBody'>
								<div className='d-flex flex-column' style={{ minHeight: '100%' }}>
									<p className="cbSubduedText mb-4">Use the following keys and values for your AI Assistant WooCommerce integration.</p>
									{hardcodedKeys.map((keyConfig) => {
										const value = getValueForKey(keyConfig.key);
										return (
											<div key={keyConfig.key} className="py-1 mt-2 copyTextInputWrap">
												<Label className="fw-bold mb-2">{keyConfig.label}</Label>
												<div className="relative maxW450">
													<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
														<input
															className="mx-3 cbNoSearchInputDecoration"
															type="text"
															id={`${keyConfig.key}Input`}
															ariaInvalid="false"
															readOnly
															value={value}
														/>
													</div>
													<Button
														color='link'
														className="copyButton"
														ariaLabel="Copy to clipboard"
														onClick={() => handleCopy(keyConfig.key, value)}
													>
														<CBToolTip item={{ placement: 'top', text: copyTexts[keyConfig.key] || "Copy to clipboard" }} id={`${keyConfig.key}Tooltip`}>
															<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
																<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
																<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
															</svg>
														</CBToolTip>
													</Button>
												</div>
											</div>
										);
									})}
									<div className="d-flex justify-content-end mt-auto pt-4">
										<Button
											color='primary'
											className='cta autoWidth'
											type="button"
											onClick={handleGoToDashboard}
											disabled={isLoading}
										>
											{isLoading ? (
												<>
													<Spinner
														className="white mr-1"
														size="sm"
														color="light"
													/>
													<span className="ml-2 d-inline-block">Loading</span>
												</>
											) : (
												"Go to Dashboard"
											)}
										</Button>
									</div>
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</section>
		</>
	);
}

export default AiAssistantWooCommerceSettings;
